import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import BaileyHeadshot from './assets/bailey_headshot.png';
import EmmaHeadshot from './assets/emma_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'ACT Score', score: 30, scoreIncrease: '+5 Point Increase' }
          ]}
          studentAvatar={BaileyHeadshot}
          studentName="Bailey"
          style={{ height: '100%' }}
        >
          Magoosh was a super-helpful tool! It helped me get used to the testing format, as well as study the material that I was a bit spotty on.
        </QuoteCardWithScoreImprovements>
      </div>

      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'ACT Score', score: 32, scoreIncrease: '+3 Point Increase' }
          ]}
          studentAvatar={EmmaHeadshot}
          studentName="Emma"
          style={{ height: '100%' }}
        >
          I was able to focus on one subject, math, in my case, and that helped me a lot. I really liked how I could go at my own pace and complete lessons based on my weaknesses.
        </QuoteCardWithScoreImprovements>
      </div>
    </div>
  );
};
